import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = {
  key: 0,
  class: "sec-main acceleratorD-main pb-0"
}
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_10 = { class: "row mb-4" }
const _hoisted_11 = { class: "col-sm-10 mx-auto" }
const _hoisted_12 = { class: "board bg-white" }
const _hoisted_13 = { class: "head-row fcsb flex-md-row" }
const _hoisted_14 = { class: "h2 me-md-3 flex-grow-1 text-primary order-md-0 order-2" }
const _hoisted_15 = { class: "tag btn-primay filled flex-shrink-0 px-4 py-md-0 py-1 mb-md-0 mb-3" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "地區", -1)
const _hoisted_18 = { class: "funds-source-group frcs" }
const _hoisted_19 = { class: "funds-source frcs me-md-4 me-2" }
const _hoisted_20 = { class: "h4 ps-md-2 ps-1" }
const _hoisted_21 = { class: "mb-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "資金性質", -1)
const _hoisted_23 = { class: "funds-source-group frcs" }
const _hoisted_24 = { class: "h4 ps-md-2 ps-1" }
const _hoisted_25 = { class: "mb-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "資金額度", -1)
const _hoisted_27 = { class: "funds-source-group frcs" }
const _hoisted_28 = { class: "funds-source frcs me-md-4 me-2" }
const _hoisted_29 = { class: "h4 ps-md-2 ps-1" }
const _hoisted_30 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "特定對象", -1)
const _hoisted_32 = { class: "funds-source-group frcs" }
const _hoisted_33 = { class: "h4 ps-md-2 ps-1" }
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "資金介紹", -1)
const _hoisted_36 = { class: "h4 pre-text" }
const _hoisted_37 = { class: "mb-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "申請說明", -1)
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { class: "mb-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "適用對象", -1)
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "資金額度說明", -1)
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { class: "mb-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "主辦單位", -1)
const _hoisted_48 = { class: "h4" }
const _hoisted_49 = { class: "mb-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "聯絡資訊", -1)
const _hoisted_51 = { class: "h4 pre-text" }
const _hoisted_52 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "網址", -1)
const _hoisted_54 = { class: "h4" }
const _hoisted_55 = ["href"]
const _hoisted_56 = {
  key: 3,
  class: "mb-4"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "文件下載", -1)
const _hoisted_58 = ["href"]
const _hoisted_59 = { class: "h4 flex-grow-1" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "frce mt-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "javascript:void(history.go(-1))",
    class: "btn-anchor back",
    aria: "返回前頁"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "返回前頁")
  ])
], -1)
const _hoisted_61 = {
  key: 1,
  class: "recommend-sec"
}
const _hoisted_62 = { class: "container-lg" }
const _hoisted_63 = { class: "col-sm-10 mx-auto" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "h2 mb-3 text-primary" }, "看其他補助", -1)
const _hoisted_65 = {
  class: "d-grid lists-group",
  "grid-column": "2"
}
const _hoisted_66 = { class: "frsb mb-2 mb-md-3" }
const _hoisted_67 = { class: "h3 me-5 me-md-3 flex-grow-1" }
const _hoisted_68 = { class: "tag btn-primay active flex-shrink-0 px-4 py-md-0 py-1" }
const _hoisted_69 = { class: "w-md-85" }
const _hoisted_70 = { class: "funds-list fcss" }
const _hoisted_71 = { class: "funds-source-group frcs" }
const _hoisted_72 = { class: "h5 ps-md-2 ps-1 pe-md-3" }
const _hoisted_73 = { class: "funds-quota frcs" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "h5 me-3" }, "資金額度", -1)
const _hoisted_75 = { class: "h5 text-primary" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "link-anchor"
  }, "詳細內容")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.item)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("nav", _hoisted_5, [
                _createElementVNode("ol", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: "/",
                      title: "首頁",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("首頁")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: "/funds",
                      title: "資源搜尋",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("資源搜尋 - 資金快搜")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.item.name), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h1", _hoisted_14, _toDisplayString(_ctx.item.name), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.item.location?.message), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.item.location?.message), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sort(_ctx.item.fundTypes, this.fundTypeOrder), (type) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: type,
                          class: "funds-source frcs me-md-4 me-2"
                        }, [
                          _createElementVNode("div", _hoisted_24, _toDisplayString(type.message) + _toDisplayString(type.name == 'OTHER' ? '：' + _ctx.item.fundTypeOther : ''), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.item.amount?.message), 1)
                      ])
                    ])
                  ]),
                  (_ctx.item.fundObjects && _ctx.item.fundObjects.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.fundObjects, (object) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: object,
                              class: "funds-source frcs me-md-4 me-2"
                            }, [
                              _createElementVNode("div", _hoisted_33, _toDisplayString(object.message) + _toDisplayString(object.name == 'OTHER' ? '：' + _ctx.item.fundObjectOther  : ''), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.item.introduce), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("div", {
                      class: "h4 editor-html",
                      innerHTML: _ctx.item.description
                    }, null, 8, _hoisted_39)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", {
                      class: "h4 editor-html",
                      innerHTML: _ctx.item.objectDescription
                    }, null, 8, _hoisted_42)
                  ]),
                  (_ctx.item.limitDescription)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("div", {
                          class: "h4 editor-html",
                          innerHTML: _ctx.item.limitDescription
                        }, null, 8, _hoisted_45)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.item.organizer), 1)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.item.contact), 1)
                  ]),
                  (_ctx.item.url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("a", {
                            href: _ctx.item.url,
                            title: "另開新視窗",
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, _toDisplayString(_ctx.item.url), 9, _hoisted_55)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.item.files?.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _hoisted_57,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.files, (file) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: file,
                            href: file.path,
                            class: "download-file d-flex mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_59, _toDisplayString(file.name), 1)
                          ], 8, _hoisted_58))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_60
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.others)
      ? (_openBlock(), _createElementBlock("section", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _hoisted_64,
              _createElementVNode("div", _hoisted_65, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.others, (other) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: other.id,
                    class: "list-card mb-md-3 mb-2"
                  }, [
                    _createVNode(_component_router_link, {
                      to: {name: 'funds-detail', params: { id: other.id }},
                      title: "看其他補助",
                      class: "foo: false"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, _toDisplayString(other.name), 1),
                          _createElementVNode("div", _hoisted_68, _toDisplayString(other.location.message), 1)
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(other.fundTypes, (type) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: type,
                                  class: "funds-source frcs me-3"
                                }, [
                                  _createElementVNode("div", _hoisted_72, _toDisplayString(type.message), 1)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_73, [
                              _hoisted_74,
                              _createElementVNode("div", _hoisted_75, _toDisplayString(other.amount.message), 1)
                            ])
                          ])
                        ]),
                        _hoisted_76
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}